
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
import { ContactService } from '../../../../common/services/Contact.service';
import { Select2Module } from 'ng2-select2';
import { SettingsComponent } from './settings.component';
import { UserComponent } from './user/user.component';
import { ServiceComponent } from './service/service.component';
import { PriorityComponent } from './priority/priority.component';
import { TypeComponent } from './type/type.component';
import { TicketComponent } from './ticket/ticket.component';
import { IvrgatewayComponent } from './gateway/ivrgateway.component';
import { QueueAgentComponent } from './queue/queue_agent.component';
import { QueueComponent } from './queue/queue.component';
import { ChatConfigComponent } from './chat/chat_config.component';
import { UserFieldComponent } from './user_field/user_field.component';
import { FieldComponent } from './ticket/field/field.component';
import { EmailComponent } from './email/mail.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { IvrComponent } from './ivr/ivr.component';
import { TimeComponent } from './time/time.component';
import { FullCalendarModule } from 'ng-fullcalendar';
import { ColorPickerModule } from 'ngx-color-picker';
import { TemplateComponent } from './template/template.component';
import { PageComponent } from './pages/page.component';
import { AccountComponent } from './account/account.component';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';



@NgModule({
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        GrowlModule,
        TooltipModule,
        BrowserModule,
        HelperModule,
        CardModule,
        PaginationModule,
        ToastrModule.forRoot(),
        Select2Module,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        FullCalendarModule,
        ColorPickerModule,
        BsDatepickerModule.forRoot()
    ],

    declarations: [
        SettingsComponent,
        UserComponent,
        ServiceComponent,
        PriorityComponent,
        TypeComponent,
        TicketComponent,
        IvrgatewayComponent,
        QueueComponent,
        QueueAgentComponent,
        ChatConfigComponent,
        UserFieldComponent,
        FieldComponent,
        EmailComponent,
        IvrComponent,
        TimeComponent,
        TemplateComponent,
        PageComponent,
        AccountComponent,
        PageComponent,
        BlacklistComponent,
    ],
    exports: [SettingsComponent],
    entryComponents: [QueueAgentComponent],
    providers: [UploadEvsService, ContactService]
})

export class SettingsModule {
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/settings.module.ts